import { ArrowUUpLeft } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';

interface UndoPromptButtonProps {
  showUndoTranslateButton: boolean;
  showUndoPromptButton: boolean;
  isLoading: boolean;
  handleUndo: () => void;
}

export const UndoPromptButton = ({
  showUndoTranslateButton,
  showUndoPromptButton,
  isLoading,
  handleUndo,
}: UndoPromptButtonProps) => {
  if ((!showUndoTranslateButton && !showUndoPromptButton) || isLoading) {
    return null;
  }

  return (
    <Button shape="round" color="secondary-outline" onClick={handleUndo}>
      <ArrowUUpLeft size={SVG_SIZE_M} />
    </Button>
  );
};
